import React, { Component } from "react";
import { Route } from "react-router-dom";
import Login from "./pages/Login/Login";
import Home from "./pages/Home/Home";
import Category from "./pages/Category/Category";
import Register from "./pages/Register/Register";
import PhoneVerify from "./pages/PhoneVerify/PhoneVerify";
import Offers from "./pages/Offers/Offers";
import NoMatch from "./pages/NoMatch/NoMatch";
import Cart from "./pages/Cart/Cart";
import SingleProduct from "./pages/SingleProduct/SingleProduct";
import Profile from "./pages/Profile/Profile";
import Checkout from "./pages/Checkout/Checkout";
import OrderDone from "./pages/OrderDone/OrderDone";
import Support from "./pages/Support/Support";
class Routes extends Component { 
    render() { 
        return (
            <> 
                <Route exact path="/" render={() => <Home />} />

                <Route exact path="/login" render={() => <Login />} />  
                <Route exact path="/register" render={() => <Register />} /> 
                <Route exact path="/phone-verification" render={() => <PhoneVerify />} /> 

                <Route exact path="/profile" render={() => <Profile />} /> 
                <Route exact path="/profile/:id/:name" render={() => <Profile />} />  
                <Route exact path="/profile/:id/:name/:orderID" render={() => <Profile />} />  

                <Route exact path="/category/:id/:name" render={() => <Category />} />
                <Route exact path="/search/:name" render={() => <Category />} />
                <Route exact path="/level/:catID/:catName/:id/:name" render={() => <Category />} />  
                <Route exact path="/subLevel/:catID/:catName/:lvlID/:lvlName/:id/:name" render={() => <Category />} /> 
                <Route exact path="/brand/:id/:name" render={() => <Category />} />  
                
                <Route exact path="/offers" render={() => <Offers />} /> 
                <Route exact path="/offers/:id/:name" render={() => <Offers />} /> 
                <Route exact path="/cart" render={() => <Cart />} />
                <Route exact path="/checkout" render={() => <Checkout />} />
                <Route exact path="/order-placed" render={() => <OrderDone />} />
                <Route exact path="/product/:id/:name" render={() => <SingleProduct />} />

                <Route exact path="/support" render={() => <Support />} /> 

                <Route exact path="/404" component={NoMatch}/> 
                </>
        )}
}

export default Routes;